<template>
  <div class="row">
    <div class="col-md-10 offset-md-1 px-md-0 col-lg-8 offset-lg-2 px-lg-3 col-xl-7 offset-xl-2 px-xl-0">
      <slot />
    </div>
    <div v-if="$slots['right-column']"
         class="col-md-10 offset-md-1 px-md-0 col-lg-8 offset-lg-2 px-lg-3 col-xl-3 offset-xl-0 ps-xl-3">
      <slot name="right-column" />
    </div>
  </div>
</template>

<script>
export default {
}
</script>
